import { QUANTITY_DEFINITION_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export function QuantityDefinitionPatch(qdId, data){
  const api = `${QUANTITY_DEFINITION_API}${qdId}/`;
  return axiosHttp.patch(api, data);
}
